import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import API_BASE_URL, { Providers } from '../services/Config';
const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [data, setData] = useState([]);
  const [loading, setloading] = useState(false);
  const [chipChange, setChipChange] = useState(0);

  const token = localStorage.getItem('authToken');
  const userData = JSON.parse(localStorage.getItem('userData'));
  const provider_id = userData ? userData['provider_id'] : null;
  const policy_id = localStorage.getItem('policy_id');

  
  const fetch = useCallback(async () => {
    if (!policy_id || !token) {
      return;
    }
    
    try {
      const res1 = await axios.post(
        `${API_BASE_URL()}/v3/applications/self/${Providers()}/search-policies-by-code`,
        { code: policy_id },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      
      const res2 = await axios.post(
        `${API_BASE_URL()}/v3/applications/self/${Providers()}/detailed-view`,
        {
          policy_id: res1?.data?.elements[0].policy_id,
          clientservice_id: res1?.data?.elements[0].clientservice_id,
          quote_id: res1?.data?.elements[0].quote_id,
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      setData(res2?.data);
    } catch (err) {
      toast.error(err.message || 'An error occurred');
    }
  }, [provider_id, policy_id, token ,chipChange]);

  useEffect(() => {
    if (policy_id) {
      setloading(true);
      fetch().finally(() => setloading(false));
    }
  }, [fetch]);

  return (
    <GlobalContext.Provider value={{ data, setData, loading, setloading , setChipChange }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => useContext(GlobalContext);
